import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=5738e245&scoped=true&"
var script = {}
import style0 from "./contact.vue?vue&type=style&index=0&id=5738e245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738e245",
  null
  
)

export default component.exports